import { createTheme } from '@mui/material/styles';

export const getTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? 'rgb(51, 181, 255)' : 'rgb(0, 162, 255)',
    },
    secondary: {
      main: '#7C4DFF', // Deep Purple Accent 200 - softer and prettier than previous red
    },
    action: {
      hover: mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
    },
    background: {
      default: mode === 'dark' ? '#1a1b1e' : '#ffffff',
      paper: mode === 'dark' ? '#25262b' : '#ffffff', // Slightly lighter dark mode paper
    },
    custom: {
      importButton: 'rgb(0, 162, 255)',
      gradientStart: mode === 'dark' ? '#1a1b1e' : '#ffffff',
      gradientEnd: mode === 'dark' ? 'rgba(51, 181, 255, 0.25)' : 'rgba(0, 162, 255, 0.15)',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          transition: 'background-color 0.5s ease, color 0.5s ease',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'dark' ? '#121212' : '#fff',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: mode === 'dark' 
            ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)' 
            : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
    },
  },
});
